export const calculateMarginPercentage = (
  totalSellingAmount: number | undefined,
  totalPurchaseAmount: number | undefined,
) => {
  if (!totalSellingAmount) return null;

  return (1 - (totalPurchaseAmount ?? 0) / totalSellingAmount) * 100;
};
